import { Redirect } from "react-router-dom";
import useAuth from "../../contexts/auth";

export default function Admin() {
  const { user } = useAuth();

  if (user && user.type !== "admin") {
    console.log(user.type)
    return <Redirect to="/" />;
  } else {
    console.log(user.type)
    return <Redirect to="/admin/dashboard" />;
  }
}
